// eslint-disable-next-line import/prefer-default-export
export enum ToastTypes {
  ERROR = 'error',
  SUCCESS = 'success',
}
